import Chip from '@ixigo/iui/Chip';
import Typography from '@ixigo/iui/Typography';
import { Skeleton } from '@repo/shared/components';
import type { BookingStatus, RideStatus } from '@/api';
import type { TransformedBookingInfo } from './utils';

const DEFAULT_CAB_IMAGE_URL =
	'https://images.ixigo.com/image/upload/cabAssets/11dabbf6f0aa6625a3e2788478254ecb-hcbbs.png';

const BOOKING_STATUS_MAP: { [key in BookingStatus]?: { title: string } } = {
	CONFIRMED: {
		title: 'Ride Confirmed',
	},
	COMPLETED: {
		title: 'Ride Completed',
	},
	CANCELLED: {
		title: 'Ride Cancelled',
	},
	PAYMENT_PENDING: {
		title: 'Payment Pending',
	},
	PAYMENT_SUCCESS_BOOKING_PENDING: {
		title: 'Payment Pending',
	},
	FAILED: {
		title: 'Booking Failed',
	},
};

const RIDE_STATUS_MAP: { [key in RideStatus]?: { title: string } } = {
	CAB_ASSIGNED: {
		title: 'Cab Assigned',
	},
	CAB_ARRIVED: {
		title: 'Cab Arrived',
	},
	TRIP_STARTED: {
		title: 'Trip Started',
	},
	TRIP_ENDED: {
		title: 'Trip Ended',
	},
};

interface RideDetailProps {
	loading: boolean;
	rideDetails?: TransformedBookingInfo['rideDetails'];
	bookingStatus?: BookingStatus;
	rideStatus?: RideStatus;
}

export const RideDetail = ({
	loading,
	rideDetails,
	bookingStatus,
	rideStatus,
}: RideDetailProps) => {
	const { pickup } = rideDetails || {};
	const pickupFormattedDateTime = pickup?.dateTime;
	const statusConfig = bookingStatus && BOOKING_STATUS_MAP[bookingStatus];
	const rideStatusConfig = rideStatus && RIDE_STATUS_MAP[rideStatus];
	return (
		<div className="flex gap-2.5">
			<div className="p-0.5 rounded-lg bg-tertiary size-30 flex items-center justify-center">
				<img src={DEFAULT_CAB_IMAGE_URL} alt="cab-ride" />
			</div>
			<div className="flex flex-col gap-0.5">
				<Skeleton loading={loading} height={16} width={90} variant="circular">
					{statusConfig && (
						<Chip
							size="xs"
							variant="soft"
							color="success"
							clickable={false}
							className="w-fit"
						>
							{rideStatusConfig ? rideStatusConfig.title : statusConfig.title}
						</Chip>
					)}
				</Skeleton>
				<Skeleton
					loading={loading}
					height={16}
					level="body-xs"
					variant="circular"
				>
					<Typography variant="body-xs">
						Pickup at{' '}
						<span className="font-medium">{pickupFormattedDateTime}</span>
					</Typography>
				</Skeleton>
			</div>
		</div>
	);
};
